import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Medical from '@/views/medical'
import Health from '@/views/health'
import Travel from '@/views/travel'
import Horsemanship from '@/views/horsemanship'
import About from '@/views/about'
import Contact from '@/views/contact'

//产品
import Product from '@/views/product'
import ProductList from '@/views/productItem'
import ProductDetails from '@/views/productDetails'

//文章
import Artical from '@/views/artical'

//医疗文章
import MedicalList from '@/views/artical/medicalList'
import MedicalContent from '@/views/artical/medicalContent'

//健康文章
import HealthList from '@/views/artical/healthList'
import HealthContent from '@/views/artical/healthContent'

//旅行文章
import TravelList from '@/views/artical/travelList'
import TravelContent from '@/views/artical/travelContent'

//马术文章
import HorseList from '@/views/artical/horseList'
import HorseContent from '@/views/artical/horseContent'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [{
            path: '/',
            redirect: '/index'
        },
        {
            path: '/index',
            name: 'Index',
            component: Index,
            meta: {
                title: 'LOTO-HOF',
                keepAlive: true,
            }
        },
        {
            path: '/medical',
            name: 'Medical',
            component: Medical,
            meta: {
                title: '医疗',
                keepAlive: true,
            }
        },
        {
            path: '/health',
            name: 'Health',
            component: Health,
            meta: {
                title: '健康',
                keepAlive: true,
            }
        },
        {
            path: '/travel',
            name: 'Travel',
            component: Travel,
            meta: {
                title: '旅行',
                keepAlive: true,
            }
        },
        {
            path: '/horsemanship',
            name: 'Horsemanship',
            component: Horsemanship,
            meta: {
                title: '马术',
                keepAlive: true,
            }
        },
        {
            path: '/about',
            name: 'About',
            component: About,
            meta: {
                title: '关于我们',
                keepAlive: true,
            }
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact,
            meta: {
                title: '联系我们',
                keepAlive: true,
            }
        },
        {
            path: '/product',
            name: 'Product',
            component: Product,
            meta: {
                title: '医疗产品',
                keepAlive: true,
            },
            children: [{
                    path: '/',
                    name: 'ProductList',
                    component: ProductList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/productDetails',
                    name: 'ProductDetails',
                    component: ProductDetails,
                    meta: {
                        keepAlive: true,
                    },
                }
            ]
        },
        {
            path: '/artical',
            name: 'artical',
            component: Artical,
            meta: {
                title: '新闻资讯',
                keepAlive: true,
            },
            children: [{
                    path: '/healthList',
                    name: 'HealthList',
                    component: HealthList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/healthContent',
                    name: 'HealthContent',
                    component: HealthContent,
                    meta: {
                        keepAlive: true,
                    },
                }, {
                    path: '/travelList',
                    name: 'travelList',
                    component: TravelList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/travelContent',
                    name: 'travelContent',
                    component: TravelContent,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/horseList',
                    name: 'HorseList',
                    component: HorseList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/horseContent',
                    name: 'HorseContent',
                    component: HorseContent,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/medicalList',
                    name: 'MedicalList',
                    component: MedicalList,
                    meta: {
                        keepAlive: true,
                    },
                },
                {
                    path: '/medicalContent',
                    name: 'MedicalContent',
                    component: MedicalContent,
                    meta: {
                        keepAlive: true,
                    },
                }
            ]
        },

    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js